<template>
  	<div class="login-container">
    <el-form :model="loginForm" ref="loginForm" :rules="rules" status-icon class="login-form">
      	<div class="title-container">
        	<h3 class="title">后台管理系统</h3>
      	</div>
      	<el-form-item prop="userName">
        	<el-input placeholder="请输入您的账号" type="text" v-model="loginForm.userName" />
      	</el-form-item>
      	<el-form-item prop="password">
        	<el-input placeholder="请输入您的密码" type="password" v-model="loginForm.password" />
      	</el-form-item>
      	<el-button type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="submit">登录</el-button>
    </el-form>
  	</div>
</template>
<script>
import md5 from "js-md5";
export default {
  	data() {
    	return {
	      	loginForm: {
		        userName: "admin",
		        password: "yewuh6vy"
	      	},
	      	rules: {
	        	userName: [{ required: true, message: "请输入手机号", trigger: "blur" }],
	        	password: [{ required: true, message: "请输入密码", trigger: "blur" }]
	      	}
    	};
  	},
  	created() {
	    var lett = this;
	    document.onkeydown = function(e) {
	      	var key = window.event.keyCode;
	      	if (key == 13) {
	        	lett.submit();
	      	}
	    };
  	},
  	methods: {
    	submit() {
      		this.$refs.loginForm.validate(valid => {
        		if (valid) {
	          		this.loading = true;
	          		let loginParams = {
			            userName: this.loginForm.userName,
			            password: md5(this.loginForm.password)
	          		};
          			this.$post("/login", JSON.stringify(loginParams))
            		.then(res => {
            			console.log(res)
              			this.loading = false; 
              			if (res.code == 0) {
			                var token = res.data.saTokenInfo.tokenValue;
			                console.log(token);
			                this.$store.commit("token");
			                localStorage.setItem("token", token);
			                localStorage.setItem("userId", res.data.saTokenInfo.loginId);
			                localStorage.setItem("nickname", res.data.nickname);
			                localStorage.setItem("userMenu", JSON.stringify(Array.isArray(res.data.userMenu)?res.data.userMenu:[]));
			                localStorage.setItem("userMenuButton", JSON.stringify(Array.isArray(res.data.userMenuButton)?res.data.userMenuButton:[]));
			                localStorage.setItem("sysRoleId", res.data.sysRoleId);//用户角色 1:后台管理 6：教练管理员 4：教练 5：教练" 7:运营
			                if(res.data.sysRoleId==7){
			                	this.$router.push({ path: "/videolists" });
			                }else if(res.data.sysRoleId==8){
			                	this.$router.push({ path: "/questionnaireList" });
			                }else if(res.data.sysRoleId!=1 && res.data.sysRoleId!=7){
			                	this.$router.push({ path: "/courseslist" });
			                }else{
			                	this.$router.push({ path: "/courses" });
			                }
			                
              			} else {
			                this.$message({
			                  	message: res.message,
			                  	type: "warning"
			                });
			                return false;
              			}
            		})
		            .catch(() => {
		              	this.loading = false;
		            });
        		} else {
          			console.log("error submit!!");
          			return false;
        		}
      		});
    	}
  	}
};
</script>
<style rel="stylesheet/scss" lang="scss">  
$bg: #283443;
$light_gray: #eee;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  	.login-container .el-input input {
    	color: $cursor;
	    &::first-line {
	      color: $light_gray;
	    }
 	}
}
.login-container {
  	position: fixed;
  	height: 100%;
  	width: 100%;
  	background-color: $bg;
  	.login-form {
	    position: absolute;
	    left: 0;
	    right: 0;
	    width: 520px;
	    max-width: 100%;
	    padding: 35px 35px 15px 35px;
	    margin: 120px auto;
  	}
  	.title-container {
    	position: relative;
    	.title {
	      	font-size: 26px;
	      	color: $light_gray;
	      	margin: 0px auto 40px auto;
	      	text-align: center;
	      	font-weight: bold;
    	}
    	.set-language {
	      	color: #fff;
	      	position: absolute;
	      	top: 5px;
	      	right: 0px;
    	}
  	}
  	.el-input {
	    display: inline-block;
	    height: 47px;
    	input {
	      	background: transparent;
	      	border: 0px;
	      	-webkit-appearance: none;
	      	border-radius: 0px;
	      	padding: 12px 5px 12px 15px;
	      	color: $light_gray;
	      	height: 47px;
	      	caret-color: $cursor;
	      	&:-webkit-autofill {
		        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
		        -webkit-text-fill-color: $cursor !important;
	      	}
    	}
  	}
  	.el-form-item {
	    border: 1px solid rgba(255, 255, 255, 0.1);
	    background: rgba(0, 0, 0, 0.1);
	    border-radius: 5px;
	    color: #454545;
  	}
}
</style>





// WEBPACK FOOTER //
// src/views/login/index.vue